module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-03-Scale.225c17ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-03-Scale.jpg
// module id = 946
// module chunks = 37